import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CategoryService } from 'src/app/services/category.service';
import * as arrayToTree from 'array-to-tree';
import { TreeDragDropService } from 'primeng/api';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { DndDropEvent } from 'ngx-drag-drop';
import { INote } from 'src/app/intefaces/INote';
import { HttpAlertService } from 'src/app/services/http-alert.service';

export interface ICategory {
  id: number;
  name: string;
  edit?: boolean;
  leaf?: boolean;
  expanded?: boolean;
  parent_id: number;
  onDragover?: boolean;
  orderIndex: number;
}

@Component({
  selector: 'app-category',
  providers: [TreeDragDropService],
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  constructor(private categoryService: CategoryService, private browserStorageService: BrowserStorageService, private alertService: HttpAlertService) {

  }

  public category: ICategory;
  public categoryList: Array<ICategory> = [];
  public categoryTreeList: any = [];
  public selectedCategories = [];
  public onSelectedCategories: Array<any> = [];
  public editedNode: ICategory;
  public notes: INote[] = [];
  public loadingNotes: boolean = false;
  public editMode: boolean = false;
  public isAdmin: boolean = (this.browserStorageService.get("_role") == "admin") ? true : false;
  public visibleConfirmMoveOrCopy: boolean = false;

  public applayNode;
  public displayEditNode: boolean = false;

  draggable = {
    // note that data is handled with JSON.stringify/JSON.parse
    // only set simple data or POJO's as methods will be lost
    data: { test: 1, test2: "asdasdsad" },
    effectAllowed: "all",
    disable: false,
    handle: false
  };

  onDragStart(event: DragEvent) {

    console.log("drag started", JSON.stringify(event, null, 2));
  }

  onDragEnd(event: DragEvent) {
    this.categoryList.map(d => {
      d = d,
        d.onDragover = false
    })
    this._toTree();
    console.log("drag ended", JSON.stringify(event, null, 2));
  }

  onDraggableCopied(event: DragEvent) {

    console.log("draggable copied", JSON.stringify(event, null, 2));
  }

  onDraggableLinked(event: DragEvent) {

    console.log("draggable linked", JSON.stringify(event, null, 2));
  }

  onDraggableMoved(event: DragEvent) {

    console.log("draggable moved", JSON.stringify(event, null, 2));
  }

  onDragCanceled(event: DragEvent) {
    console.log("drag cancelled", JSON.stringify(event, null, 2));
  }

  onDragover(event: DragEvent, node) {
    node.onDragover = true;
    console.log("dragover", JSON.stringify(event, null, 2));
  }


  public elementDrop: INote;
  public elementDragover: ICategory;

  onDrop(event: DndDropEvent, category) {
    this.visibleConfirmMoveOrCopy = true;
    this.elementDrop = event.data;
    const c = {
      ...category,
      parent: null,
      children: null
    }
    this.elementDragover = c;
  }

  @Output('onSelectCategory') onSelectCategory = new EventEmitter<any>();

  private categoryLoaded;
  public nodeSelect(event) {

    if (this.selectedCategories.length == 0) {
      this.selectedCategories.push(event.node);
    }
    this.onSelectCategory.emit(this.selectedCategories);
    this.category.parent_id = this.selectedCategories[0].id;
    if (this.isAdmin) {
      this.categoryLoaded = event.node;
      this.onLoadNotesByCategory(event.node);
    }


  }

  @Input()
  set categories(cat) {
    this.onSelectedCategories = cat || [];
  }

  ngOnInit(): void {
    this.initCategory();
    this.getCategories();
  }

  onCopyOrMoveElement(mode) {
    const object = {
      mode: mode,
      category: this.elementDragover,
      note: this.elementDrop,
      selectedCategory: {
        ...this.selectedCategories[0],
        children: null,
        parent: null
      }
    };


    this.categoryService.copyOrMoveNoteCategory(object).subscribe(data => {
      if (data.success === false) {
        if (data.message == "not_copy") {
          this.alertService.warn("Nie skopiowano. Utwór jest w ostatniej kategorii.");
        }
        if (data.message == "not_move") {
          this.alertService.warn("Nie przeniesiono. Utwór jest w ostatniej kategorii.");
        }
      }

      if (data.success === true && data.message == "copied") {
        this.alertService.success("Skopiowano.");
      }

      if (data.success === true && data.message == "movied") {
        this.alertService.success("Przeniesiono.");
      }

      this.onEndCopyOrMove();
      this.onLoadNotesByCategory(this.categoryLoaded);
    });
  }

  onMoveElement() {
    console.log("onMoveElement");
    console.log("this.elementDragover", this.elementDragover);
    console.log("this.elementDrop", this.elementDrop);
    this.onCopyOrMoveElement('move');
  }

  onCopyElement() {
    this.onCopyOrMoveElement('copy');
  }

  onDeleteElementFromCategory(e, note) {
    e.preventDefault();
    if (confirm("Czy na pewno chcesz usunać ten utwór ?")) {
      this.deleteElementFromCategory(note);
    }

  }

  deleteElementFromCategory(note) {
    const object = {
      category: {
        ...this.selectedCategories[0],
        children: null,
        parent: null
      },
      note: note
    };
    this.categoryService.deleteNoteFromCategory(object).subscribe(data => {
      console.log(data); // utwor jest w ostatniej kategorii
      if (data.data === false) {
        this.alertService.warn("Utwór nie został usunięty. Jest w ostatniej kateogrii.");
      }
      if (data.data === true) {
        this.alertService.success("Utwór został usunięty z kategorii");
      }
      this.onLoadNotesByCategory(this.categoryLoaded);
      this.getCategories();
    }, () => {
      this.loadingNotes = false;
    });
  }

  onEndCopyOrMove() {
    this.visibleConfirmMoveOrCopy = false;
    this.getCategories();
  }

  private initCategory() {
    this.category = {
      id: null,
      name: null,
      parent_id: 0,
      orderIndex: 1
    }
  }


  getNotesByCategory(category) {
    const cat = {
      id: category.id
    }
    this.categoryService.getNotesByCategoryId(cat).subscribe(data => {
      console.log(data);
      this.notes = data.data;
      this.loadingNotes = false;
    }, () => {
      this.loadingNotes = false;
    });
  }

  onLoadNotesByCategory(category) {
    this.loadingNotes = true;
    this.getNotesByCategory(category);
  }

  editOrder(category) {
    this.category.id = category.id;
    this.category.name = category.name;
    this.category.orderIndex = category.orderIndex;
    this.category.parent_id = category.parent_id;
    this.editCategory(this.category);
  }

  onDropC(event) {

    this.category.id = event.dragNode.id;
    this.category.name = event.dragNode.name;
    this.category.orderIndex = event.dragNode.orderIndex;
    this.category.parent_id = event.dropNode.id;
    this.editCategory(this.category);
  }

  sortTree(tree) {
    let sortedTree = [...tree];
    sortedTree = sortedTree.sort((a,b) => (a.orderIndex > b.orderIndex) ? 1 : ((b.orderIndex > a.orderIndex) ? -1 : 0));

    sortedTree = sortedTree.map((node, index) => {
      if (node.children && node.children.length > 0) {
        return sortedTree[index] = {
          ...sortedTree[index],
          children: sortedTree[index].children.sort((a,b) => (a.orderIndex > b.orderIndex) ? 1 : ((b.orderIndex > a.orderIndex) ? -1 : 0))
        };
      } else {
        return sortedTree[index];
      }
    });

    return sortedTree;
  }

  private _toTree() {
    const unsortedTree = arrayToTree(this.categoryList, {
      parentProperty: 'parent_id'
    });
    this.categoryTreeList = this.sortTree(unsortedTree);

    if (this.onSelectedCategories.length > 0) {
      this.selectNodes(this.onSelectedCategories, this.categoryTreeList);
    }
  }

  public onChangeNode(node) {
    this.editedNode = node;
    this.displayEditNode = true;
  }


  onResetNode(node) {
    this.categoryService.resetCategory({ id: node.id }).subscribe(data => {
      this.initCategory();
      this.getCategories();
      this.saving = false;
    }, () => this.saving = false);
  }

  onRemoveNode(node) {
    this.categoryService.removeCategory({ id: node.id }).subscribe(data => {
      this.initCategory();
      this.getCategories();
      this.saving = false;
    }, () => this.saving = false);
  }

  public closeEditNode() {
    this.editedNode = null;
    this.initCategory();
    this.getCategories();
  }

  public onEditNode(node) {
    const editCategory: ICategory = {
      id: node.id,
      name: node.name,
      orderIndex: node.orderIndex,
      parent_id: node.parent_id
    }
    this.displayEditNode = false;
    this.editCategory(editCategory);
  }

  private selectNodes(ids: Array<any>, node) {
    if (Array.isArray(node)) {
      node.forEach(element => {
        if (ids.includes(element.id)) {
          this.selectedCategories.push(element);
        }
        this.selectNodes(ids, element.children);
      });
    }
  }

  private getCategories() {
    this.categoryService.getCategories().subscribe(data => {
      this.categoryList = data.data;
      this.categoryList.map(d => {
        d = d,
          d.expanded = true
      })
      this._toTree();
    });
  }
  public saving: boolean = false;

  private saveCategory(category: ICategory) {
    this.saving = true;
    this.categoryService.addCategory(category).subscribe(data => {
      this.initCategory();
      this.getCategories();
      this.saving = false;
    }, () => this.saving = false);
  }

  private editCategory(category: ICategory) {
    this.categoryService.editCategory(category).subscribe(data => {
      this.getCategories();
      this.initCategory();
    });
  }

  public onEdit(b) {
    this.editMode = b;
  }

  public onApplyNode(node) {
    this.applayNode = node;
    this.category.parent_id = node.id;
    this.category.id = null;
  }

  public onSaveCategory() {
    this.saveCategory(this.category);
  }
}
